export const stats = [
  { 
    percentage: '40%', 
    description: 'Falta de Controle Vacinal', 
    text: 'Quase metade dos produtores não possui um sistema eficiente para controle do calendário vacinal.' 
  },
  { 
    percentage: '35%', 
    description: 'Risco de Surtos Sanitários', 
    text: 'Mais de um terço das propriedades estão vulneráveis a surtos sanitários por falta de rastreabilidade.' 
  },
  { 
    percentage: '25%', 
    description: 'Dificuldade de Rastreabilidade', 
    text: 'Apenas um quarto dos produtores possui sistema eficiente de rastreamento animal.' 
  }
];